export const Tacitly = {
  onoff: true, //加密开关 双向加密 备用
  // Base_Port: process.env.NODE_ENV == "development" ? "" : "https://demo.dyuit.cn/xiaoyin/index.php/api/",
  Base_Port:
    process.env.NODE_ENV == "development"
      ? ""
      // : "https://test.hfajglxt.com/index.php/api/", //杭法线下
   : " https://www.xyajglxt.com/index.php/api/", //萧银线上
  // : "https://testold.hfajglxt.com/index.php/api/", //萧银线下
  // : "http://testold.test/index.php/api/",
  //  : "https://haoyun.xyajglxt.com/index.php/api/", //浩韵线上
  //  : "https://haoyun.hfajglxt.com/index.php/api/", //浩韵线下
  // name: "杭法", //线下
  name: "萧银", //线上
  // name: "浩韵",
  key: "ABWE@@#aQWow!@#$", //加密🔑
};
